import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1F337D',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

const ambiente = localStorage.ambiente;
const urlCloudfront = `https://${window.env.VUE_APP_CLOUDFRONT_NAME}/parceiros/cdc/${ambiente}/`

const logo = urlCloudfront ? `${urlCloudfront}logo` : '/assets/imgs/logo.svg'
const background = urlCloudfront ? `${urlCloudfront}background` : '/assets/imgs/background.svg'
const logoLoading = urlCloudfront ? `${urlCloudfront}logoLoading` : '/logo-inverted.svg'

function verificarImagemExiste (url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

async function montaCaminhoImagem (ambiente, nome, callback) {
  if (ambiente) {
    var url = `${urlCloudfront}${nome}`
    const existe = await verificarImagemExiste(url);
    if (!existe) {
      url = `/assets/imgs/${nome}.svg`
    }
    callback(url)
  }
}

montaCaminhoImagem(ambiente, 'favicon', (urlImagem) => {
  if (urlImagem) {
    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', urlImagem)
  }
})

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false
  },
  logo,
  background,
  logoLoading,
  themes: themes
}
